module.exports = __webpack_public_path__ + "media/img/email/tak_mil_icon-932ba03b128e57929e58ea160b3f51d7.png";